import React, {Component} from 'react'
import withStyles from '@mui/styles/withStyles'
import Button from '@mui/material/Button'
import DoneIcon from '@mui/icons-material/Done'
import classNames from 'classnames'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import {currencies} from '@bdswiss/common-enums'
import messages from '../../assets/messages'
import {Trans, withNamespaces} from 'react-i18next'
import {map, isArray, flowRight as compose, get} from 'lodash'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import {FormHelperText} from '@mui/material'
import {getFormattedAmount, isFirstRawPlan} from '../../common/utils/general'
import {withRouter} from 'react-router-dom'

const styles = theme => ({
  title: {
    color: theme.palette.secondary.dark,
    fontSize: 24,
  },
  subheader: {
    color: theme.palette.primary.main,
    fontSize: 35,
    paddingTop: 20
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing(2),
    },
  },
  cardLoadingActions: {
    display: 'block',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing(2),
    },
  },
  cardContent: {
    flex: '1 0 auto',
    justifyContent: 'center',
  },
  cardPricing: {
    textAlign: 'left'
  },
  cardRoot: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '&:hover':{
      boxShadow: `0 0 5px 0px ${theme.palette.primary.main}`
    }
  },
  cardSelected:{
    boxShadow: `0 0 5px 0px ${theme.palette.primary.main}`
  },
  textGreen:{
    color: theme.palette.green.color
  },
  textYellow:{
    color: theme.palette.yellow.color
  },
  listItem: {
    fontSize: 14,
    paddingLeft: 4,
    paddingRight: 4,
  },
  item: {
    padding: 5
  },
  currentButton:{
    '&:hover':{
      backgroundColor: 'transparent'
    }
  },
  highlightedText: {
    color: theme.palette.primary.main,
  },
  errorMessage:{
    color:  theme.palette.error.main,
  },
  dialogTitle:{
    margin: 10,
    textAlign: 'center'
  },
  symbol:{
    color:  theme.palette.secondary.dark,
    fontSize: 20
  },
  hightlight: {
    fontWeight: 400,
    color:  theme.palette.secondary.main
  },
  links: {
    textAlign: 'right',
    marginTop: 17,
    [theme.breakpoints.down('md')]: {
      marginTop: 5
    },
    cursor:'pointer'
  },
  textBlue:{
    color: theme.palette.primary.main
  },
  inlineTypography: {
    paddingLeft: '1rem',
    display:'inline-block',
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
    },
  },
  proFreeTicks:{
    paddingRight: 20,
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
      display:'block',
      lineHeight: '32px'
    }
  },
  [theme.breakpoints.down('md')]: {
    topDiv:{
      paddingBottom: '1rem'
    }
  },
})
export class PlanCard extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openChangeModal: false,
      openCancelReactivateModal: false,
      loadingProceed: false,
      loadingCancelReactivate: false,
    }
  }

  render() {
    const {classes,t, onClick, subscription, plan, currentPlan, showActions, subscriptionStatus, currentState,
      buttonAction, single, noActions, isFree} = this.props

    const subHeaderFree =`${t(messages.free.i18nKey, messages.free.defaults)}`
    const subHeader =  <span><span className={classes.symbol}>{`${currencies[get(plan, 'currency') || 'EUR']['symbol']}`}</span>{` ${get(plan, 'defaultAmount')} `}
      <span className={classes.symbol}>{`/ ${t(messages.month.i18nKey, messages.month.defaults)}`}</span></span>
    const planVolumeAmount = isFirstRawPlan(plan) ? get(plan, 'minVolume') : get(plan, 'minVolume')+0.01

    const isFreePlan = get(plan, 'isFree') && isArray(get(plan, 'isFree')) ? isFree : get(plan, 'isFree')
    return (
      <Card className={classNames(!single && classes.cardRoot, (currentPlan && !single) ? classes.cardSelected:'')}
        onClick={() => onClick && onClick()}>
        <CardHeader
          title={get(plan, 'label')}
          subheader={(!isFreePlan) ? subHeader : subHeaderFree}
          titleTypographyProps={{align: 'center'}}
          subheaderTypographyProps={{align: 'center'}}
          classes={{
            title: classes.title,
            subheader: classes.subheader,
          }}
        />
        <CardContent className={classes.cardContent}>
          <List>
            <ListItem divider={true} classes={{root: classes.item}}>
              <ListItemIcon>
                <DoneIcon className={classNames([classes.textGreen, classes.floatRight])} />
              </ListItemIcon>
              <ListItemText
                primary={`${getFormattedAmount({currency: 'USD',amount:(planVolumeAmount)})} - ${getFormattedAmount({currency: 'USD',amount:get(plan, 'maxVolume')})} ${t(messages.volume.i18nKey, messages.volume.defaults)}`}
                classes={{primary: classes.listItem}}
              />
            </ListItem>
            {map((get(plan, 'features')),(value, key) =>{
              const icon = (value === 'done')
                ? <DoneIcon className={classNames([classes.textGreen, classes.floatRight])} />
                : <InfoOutlined className={classNames([classes.textYellow, classes.floatRight])} />
              return <ListItem divider={true} key={key} classes={{root: classes.item}}>
                <ListItemIcon>
                  {icon}
                </ListItemIcon>
                <ListItemText
                  primary={t(messages[key].i18nKey, messages[key].defaults)}
                  classes={{primary: classes.listItem}}
                />
              </ListItem>
            })}
          </List>
        </CardContent>
        <CardActions className={classes.cardActions} disableSpacing>
          {showActions && !noActions && <Button fullWidth variant={(currentPlan) ? 'text' : 'contained'} color="primary"
            className={(currentPlan) ? classes.currentButton : ''} disabled={subscription && (!subscription.isActive && !subscription.isExpired)} size={'large'}
            onClick = {() => buttonAction()} >
            {(currentPlan)
              ? t(messages.currentPlan.i18nKey, messages.currentPlan.defaults)
              : <Trans {...messages[subscriptionStatus.actionText]} />
            }
          </Button>}
        </CardActions>
        {showActions && currentPlan && subscriptionStatus.currentActionText && <CardActions className={classes.cardLoadingActions} disableSpacing>
          <Button
            fullWidth
            variant="contained"
            size="large"
            color={(subscription && subscription.isActive) ? 'secondary' : 'primary'}
            onClick = {() => buttonAction(true)}
          >{<Trans {...messages[subscriptionStatus.currentActionText]} />}
          </Button>
          {currentState.statusCancelReactivate && currentState.statusCancelReactivate==='failure' &&
          <FormHelperText className={classes.errorMessage}>{currentState.cancelReactivateError}</FormHelperText>}
        </CardActions>}
      </Card>
    )
  }
}

export default compose(
  withNamespaces(),
  withStyles(styles),
  withRouter)(PlanCard)
